module.exports = __webpack_public_path__ + "img/logo.431746ab.svg";